import Signal from '@/webgl/core/Signal'
import { TimeEntity } from '@/webgl/runner/entities/Time'
import GameWorld from '@/webgl/runner/GameWorld'
import { IRunnerRenderer } from '@/webgl/runner/interfaces/IRunnerRenderer'
import { ScenarioSetup } from '@/webgl/runner/scenarios/ScenarioSetup.types'
import { IGameSegment } from '@/webgl/runner/systems/SequencingSystem'

export default class DelaySegment implements IGameSegment {
  onComplete: Signal<void> = new Signal()
  world: GameWorld

  delayComplete: boolean = false
  completed: boolean = false
  time: number = 0

  constructor(
    readonly id: string,
    readonly duration: number
  ) {}

  init(world: GameWorld, renderer: IRunnerRenderer, setup: ScenarioSetup): void {
    this.world = world
  }

  start(): void {
    this.delayComplete = false
    this.time = 0
  }

  update(time: TimeEntity): void {
    if (this.completed) return

    this.time += time.unscaledDeltaTime
    const delayComplete = this.time > this.duration

    if (delayComplete && this.world.collectibles.length == 0) {
      this.completed = true
      this.onComplete.emit()
    }
  }

  stop(): void {}
}
